import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { Label } from './Label';
import { GITHUB_URL, githubChips } from '../data/site';
export function BuildProof() {
  return <section className="w-full border-t border-navy/10 bg-cream py-24 sm:py-28" data-id="element-45" data-mp="cia7jeld42b">
      <div className="mx-auto max-w-[720px] px-5 sm:px-8" data-id="element-46" data-mp="3rjbckql4f98f">
        <Reveal data-id="element-47" data-mp="3rlxrjbaccr0o">
          <Label tone="navy" data-id="element-48" data-mp="33uaarm6smwc4">Hands on the tools</Label>
          <p className="mt-5 font-serif text-2xl italic leading-snug text-navy sm:text-[1.85rem]" data-id="element-49" data-mp="33usef3vsccu2">
            I still build. It keeps feasibility judgements honest.
          </p>
        </Reveal>

        <Reveal delay={0.06} data-id="element-50" data-mp="3dt7y4lshgjtj">
          <a href={GITHUB_URL} target="_blank" rel="noreferrer noopener" className="mt-8 inline-flex items-center gap-2 border-b border-copper/50 pb-1 font-sans text-[11px] uppercase tracking-label text-navy/70 hover:text-copper" data-id="element-51" data-mp="3dq3j0tdhc3o3">
            github.com/EricBlanvillain
            <ArrowUpRightIcon className="h-3.5 w-3.5" data-id="element-52" data-mp="3aimr9htv40q8" />
          </a>
        </Reveal>

        <Reveal delay={0.1} data-id="element-53" data-mp="3fh7w5uk278l0">
          <ul className="mt-10 flex flex-col gap-3" data-id="element-54" data-mp="3fg53pi738y2z">
            {githubChips.map(chip => <li key={chip} className="border-b border-navy/10 pb-3 font-sans text-[11px] uppercase tracking-label text-navy/55" data-id="element-55" data-mp="3kg15dasbcdfd">
                {chip}
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}